import {connect} from 'react-redux';
import * as CardCommissionAccountFormActions from '../../actions/mx/CardCommissionAccountFormActions';
import {State} from '../../../types/mx/reducers';
import {CardCommissionDeleteDispatchProps} from '../../types/mx/containers';
import * as ModalActions from '../../../../wizard/actions/ModalActions';
import {AnyAction, Dispatch} from 'redux';
import CardCommissionDeleteView from '../../components/views/mx/CardCommissionDeleteView';
import {FormFieldProps} from '../../../../common/types/components';
import {Catalog} from '../../../../common/types/common';

class CardCommissionDeleteStateProps {
}

const mapStateToProps = (state: State, ownProps): CardCommissionDeleteStateProps => {
    const {groupId, name} = state.group.form;
    const {cardCommissionDeleteReasons} = state.group.catalogs;
    const commissionCardId = (ownProps.data && ownProps.data.commissionCardId) ? ownProps.data.commissionCardId : '';
    return {
        commissionCardId,
        cardCommissionDeleteReasons,
        group: {id: groupId, value: name, payload: ''},
    };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): CardCommissionDeleteDispatchProps => {
    return {
        onPressDeleteConfirm: (commissionCardId: string) => (deleteReason: Catalog, deleteReasonOther: string) => {
            dispatch(CardCommissionAccountFormActions.
            GROUP_DELETE_CARD_COMMISSION_ACTION.action(commissionCardId, deleteReason, deleteReasonOther));
        },
        onPressClose: () => {
            dispatch(ModalActions.CLOSE_MODAL_ACTION.action());
        }
    };
};

const mergeProps = (stateProps, dispatchProps) => {
    return {
        ...stateProps,
        ...dispatchProps,
        onPressDeleteConfirm: dispatchProps.onPressDeleteConfirm(stateProps.commissionCardId)
    };
};

const CardCommissionDeleteContainer = connect(
    mapStateToProps, mapDispatchToProps, mergeProps
)(CardCommissionDeleteView);

export default CardCommissionDeleteContainer;
